module.exports = __webpack_public_path__ + "img/super-bundle-31.a879fef.webp";